import {put, takeEvery} from "redux-saga/effects";
import {Document} from "../../../Models/Document";
import {api} from "../../../lib/http";
import {documentCreateError, documentCreateSuccess, documentDestroyError, documentDestroySuccess} from "./actions";
import * as TYPES from "./types";

export default function* documentsSagas() {
    yield takeEvery(TYPES.DOCUMENT_CREATE_REQUEST, documentCreateRequest);
    yield takeEvery(TYPES.DOCUMENT_DESTROY_REQUEST, documentDestroyRequest);
}

function* documentCreateRequest(action) {
    try {
        const formData = new FormData();
        formData.append("file", action.payload.file);

        const response = yield api.post("/documents", formData, action.payload.headers || {});

        yield put(
            documentCreateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(documentCreateError(error));
    }
}

function* documentDestroyRequest(action) {
    try {
        const response = yield Document.destroy(action.payload.id);

        yield put(
            documentDestroySuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(documentDestroyError(error));
    }
}
